module.exports = __webpack_public_path__ + "img/antes_despues_76.39e0a01b.png";